import React from 'react';
import moment from 'moment';
import propTypes from 'prop-types';
import mergeI18n from '../../lib/util/merge-i18n';
import i18n from './i18n';
import {
	CONTACT_US_ROUTE,
	PRIVACY_ROUTE,
	TERMS_ROUTE
} from '../../constants/constants';

class FooterBar extends React.Component {
	render () {
		const __ = mergeI18n(this.props.language, i18n);
		return (
			<div className='footer-bar'>
				<div className='container'>
					<div className='footer-links'>
						<a
							tabIndex={0}
							role='link'
							aria-label='Privacy Policy'
							onClick={() => this.props.setRoute(PRIVACY_ROUTE)}
							onKeyDown={(e) => {
								if (e.key === 'Enter' || e.key === ' ') {
									e.preventDefault();
									this.props.setRoute(PRIVACY_ROUTE);
								}
							}}
							key='footer-link-privacy'
						>
							{__.privacy}
						</a>

						<a
							tabIndex={0}
							role='link'
							aria-label='Terms of Service'
							onClick={() => this.props.setRoute(TERMS_ROUTE)}
							onKeyDown={(e) => {
								if (e.key === 'Enter' || e.key === ' ') {
									e.preventDefault();
									this.props.setRoute(TERMS_ROUTE);
								}
							}}
							key='footer-link-terms'
						>
							{__.terms}
						</a>

						<a
							tabIndex={0}
							role='link'
							aria-label='Contact Us'
							onClick={() => this.props.setRoute(CONTACT_US_ROUTE)}
							onKeyDown={(e) => {
								if (e.key === 'Enter' || e.key === ' ') {
									e.preventDefault();
									this.props.setRoute(CONTACT_US_ROUTE);
								}
							}}
							key='footer-link-contact'
						>
							{__.contact}
						</a>
					</div>
					<div className='footer-copyright'>
						&copy; {moment().format('YYYY')} Manheim by Cox Automotive
					</div>
				</div>
			</div>
		);
	}
}

FooterBar.propTypes = {
	language: propTypes.string.isRequired,
	setParentState: propTypes.func.isRequired,
	setRoute: propTypes.func.isRequired
};
export default FooterBar;
